import { select, takeLatest, put, call } from 'redux-saga/effects';

import { ReportPayrollActions } from '../constants';
import { ReportPayrollApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    DeleteReportPayrollAction,
    GetReportPayrollAction,
    GetReportPayrollsAction,
    PaidReportPayrollAction,
} from '../actions/reportPayroll-actions';
import sortingService from '../../services/sorting';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from '../../services/api-handlers/api-resolver';
import { push } from 'connected-react-router';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { changeToZeroMomentDate } from 'src/helpers/timeHelpers';
import moment from 'moment';
import { groupDataToCsv } from '../../helpers/reports/groupCsv';
import { exportToCsv } from '../../services/exports/csv';
import { toast } from 'react-toastify';
import { GetInternalsAction } from '../actions/internal-actions';

function* handleFetchReportPayrolls(action: GetReportPayrollsAction) {
    const oldData = yield select((state: StoreState) => state.reportPayrolls.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    let propsDate = filters;

    const dataIn: AnyObject = {
        dateTo: changeToZeroMomentDate(undefined),
        dateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
    };

    if (filters && filters.periodStart) {
        filters.dateFrom = filters.periodStart;
        filters.periodStart = '';
    }
    if (filters && filters.periodEnd) {
        filters.dateTo = filters.periodEnd;
        filters.periodEnd = '';
    }

    if (filters && !filters.dateFrom) {
        propsDate = {
            ...filters,
            ...dataIn,
        };
    } else {
        propsDate = {
            ...dataIn,
            ...filters,
        };
    }

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ReportPayrollApi.getReportPayrolls({
            ...propsDate,

            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handlePaidReportcsvPayroll(action: GetReportPayrollsAction): any {
    const { filters, sorting, itemsPerPage } = action.payload;
    let page: number = action?.payload?.page ? +action.payload.page : 1;
    yield resolveApiCall(
        action,
        () =>
            ReportPayrollApi.getReportPayrolls({
                ...filters,
                dateTo: changeToZeroMomentDate(undefined),
                dateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                order: sortingService.makeOrder(sorting),
                page,
                itemsPerPage: 5000,
                pagination: itemsPerPage === -1 ? 0 : 1,
            }),

        function* (data) {
            if (data.payload.length === 5000) {
                const actionFiles: GetInternalsAction = {
                    type: ReportPayrollActions.FETCH_PAYROLLS_REPORTS_CSV,
                    payload: {
                        filters,
                        page: ++page,
                        sorting,
                        itemsPerPage: 5000,
                    },
                    all: action.all ? [...action.all, ...data.payload] : [...data.payload],
                };

                yield call(handlePaidReportcsvPayroll, actionFiles);
            } else {
                const dataAll = action.all ? [...action.all, ...data.payload] : [...data.payload];
                if (action.all) {
                    const groupCsv = groupDataToCsv(dataAll);
                    exportToCsv('payrollReport.csv', groupCsv);
                } else {
                    const groupCsvData = groupDataToCsv(data.payload);
                    exportToCsv('payrollReport.csv', groupCsvData);
                }
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
            }
            handleError(result);
        },
    );
}
function* handleFetchReportPayroll(action: GetReportPayrollAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => ReportPayrollApi.getReportPayroll(id));
}
function* handleDeleteReportPayroll(action: DeleteReportPayrollAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => ReportPayrollApi.deleteReportPayroll(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePaidReportPayroll(action: PaidReportPayrollAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        onSuccess,
        onError,
    } = payload;

    yield resolveApiCall(
        action,
        () => ReportPayrollApi.paidReportPayroll(restData),
        function* (data: ResolverApiSuccess) {
            if (onSuccess) {
                onSuccess();
            }
            yield put(push(Router.generate(routes.REPORT_PAYROLLS_LIST)));
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(ReportPayrollActions.FETCH_REPORT_PAYROLLS, handleFetchReportPayrolls);
    yield takeLatest(ReportPayrollActions.FETCH_REPORT_PAYROLL, handleFetchReportPayroll);
    yield takeLatest(ReportPayrollActions.DELETE_REPORT_PAYROLL, handleDeleteReportPayroll);
    yield takeLatest(ReportPayrollActions.PAID_REPORT_PAYROLLS, handlePaidReportPayroll);
    yield takeLatest(ReportPayrollActions.FETCH_PAYROLLS_REPORTS_CSV, handlePaidReportcsvPayroll);
}
